let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("igSTh")).then(() => parcelRequire('bZgu0'));